var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AsyncSelect',_vm._g(_vm._b({scopedSlots:_vm._u([{key:"item:description",fn:function(ref){
var item = ref.item;
return [_c('v-chip',{attrs:{"x-small":""}},[_vm._v(" "+_vm._s(item.orgName)+" ")]),(!item.isEnabled)?_c('v-chip',{staticClass:"ml-1",attrs:{"x-small":"","color":"error"}},[_vm._v(" Неактивен ")]):_vm._e()]}}])},'AsyncSelect',_vm.computedProps,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }